var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "rotate(180 32.5 32.5)",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8181 23.2219C28.0026 23.0658 28.2358 22.9861 28.4731 22.9983C28.7103 23.0104 28.935 23.1135 29.1038 23.2877C29.2727 23.4619 29.374 23.6951 29.3881 23.9423C29.4023 24.1896 29.3285 24.4336 29.1807 24.6276L22.2715 31.832L45.0671 31.832C45.3211 31.832 45.5649 31.9365 45.7454 32.1229C45.9259 32.3092 46.0286 32.5623 46.0311 32.8272C46.0311 33.0938 45.9296 33.3495 45.7488 33.538C45.568 33.7266 45.3228 33.8325 45.0671 33.8325L22.2731 33.8325L29.1823 41.0218C29.3594 41.2122 29.4584 41.467 29.4584 41.7322C29.4584 41.9974 29.3594 42.2522 29.1823 42.4426C29.0934 42.537 28.9874 42.612 28.8705 42.6632C28.7535 42.7144 28.6279 42.7408 28.501 42.7408C28.3741 42.7408 28.2486 42.7144 28.1316 42.6632C28.0146 42.612 27.9086 42.537 27.8197 42.4426L19.2748 33.5359C19.0986 33.3481 19 33.0958 19 32.8331C19 32.5704 19.0986 32.3181 19.2748 32.1302L27.8181 23.2219Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white",
    transform: "translate(47 44) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/al.5e766f1a9a06713c44d47e24a5ba4612.svg";
export { ForwardRef as ReactComponent };